export default {
    getHeaderFieldsEprofileTerapia: state => state.headerFieldsEprofileTerapia,
    getFormActionsEprofileTerapia: state => state.formActionsEprofileTerapia,
    getActionsEprofileTerapia: state => state.actionsEprofileTerapia,
    getRowActionsEprofileTerapia: state => state.rowActionsEprofileTerapia,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileTerapia: state => state.formIsOpen,
    isGridOpenEprofileTerapia: state => state.gridIsOpen
}
